import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import UneditableInput from '../../components/UneditableInput';
import DataTable from '../../components/Table/DataTable';
import Unsubscribe from './../../components/Unsubscribe/Unsubscribe';
import { formatCurrency } from '../../helpers/formatCurrency';

import { getSubscriberData, updateSubscriber } from '../../services/subscribers';
import { showAlert } from '../../store/ducks/alert';

import { CircularProgress } from '@material-ui/core';
import { HighlightOff, Star, AssignmentTurnedIn } from '@material-ui/icons';

const SubscriberInformation = props => {
  const dispatch = useDispatch();
  const [subscriber, setSubscriber] = useState({});
  const [subscribesInformation, setSubscribersList] = useState([]);
  const [paymentStats, setSubscriberPaymentStats] = useState([]);
  const [lastTransactions, setLastTransactions] = useState([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [subscription, setSubscription] = useState();

  useEffect(() => {
    displaySubscriber();
  }, []);

  const displaySubscriber = async () => {
    const subscriberId = props.match.params.uid;
    const currency = 'BRL'; //TODO temporary
    try {
      setIsLoading(true);
      const { data } = await getSubscriberData(subscriberId);
      setSubscriber({ ...data, id: subscriberId });
      setSubscribersList(
        data.subscribes.rows.map(item => {
          return {
            channelId: item.Channel.id,
            channelName: item.Channel.name,
            channelSlug: item.Channel.slug,
            isMember: item.isMember,
            isSubscriber: item.enabled,
            uid: item.uid,
            id: item.id,
            enabled: item.enabled,
            channelUserId: item.Channel.userId,
            subscriberUserId: item.userId,
          };
        })
      );

      setSubscriberPaymentStats({
        ...data.stats,
        moneySpent: formatCurrency(currency, data.stats.moneySpent),
      });
      setLastTransactions(
        data.lastTransactions.map(i => {
          return {
            ...i,
            value: formatCurrency(currency, i.value),
          };
        })
      );
      setPage(data.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
      console.log(error);
    }
  };

  const handleBecomeMember = async rowItem => {
    try {
      if (rowItem.isMember === '⛔️ Não') {
        await updateSubscriber(rowItem.id, { isMember: true });
        dispatch(showAlert('success', '🤘 Lets rock'));
      } else {
        dispatch(showAlert('error', 'This user is already a member'));
      }
    } catch (error) {
      dispatch(showAlert('error', error.message));
      console.log(error);
    }
  };

  const handleEnabledSubscriber = async rowItem => {
    try {
      if (rowItem.enabled === '⛔️ Não') {
        await updateSubscriber(rowItem.id, { enabled: true });
        dispatch(showAlert('success', '🤘 Lets rock'));
      } else {
        dispatch(showAlert('error', 'This user is already enabled'));
      }
    } catch (error) {
      dispatch(showAlert('error', error.message));
      console.log(error);
    }
  };

  const customActions = [
    {
      icon: <HighlightOff titleAccess="Unsubscribe" />,
      action: item => {
        setSubscription(item);
        setOpen(true);
      },
    },
  ];

  const handleClose = () => {
    setOpen(false);
  };

  const uneditable = ['id', 'email'];

  const uneditableStats = ['memberCount', 'donationCount', 'unsubscribesCount', 'moneySpent'];

  const headers = ['channelName', 'channelSlug', 'isMember', 'isSubscriber', 'enabled', 'channelUserId', 'subscriberUserId'];

  const lastTransactionsHeaders = ['id', 'toChannelId', 'value', 'paymentType'];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <section className="update-section">
        <h3>Subscriber Information</h3>
        <form className="update-form">
          <div className="form-fields">
            <UneditableInput data={subscriber} labels={uneditable} />
            <UneditableInput data={paymentStats} labels={uneditableStats} />
          </div>
        </form>
      </section>
      <section class="additional-section">
        <h3> Subscriptions </h3>
        <DataTable
          head={headers}
          body={subscribesInformation}
          action={true}
          bodyColumn={headers}
          linkPath="subscription"
          currentPage={page}
          noPagination={true}
          customActions={customActions}
          useUid={true}
        />
        {open ? <Unsubscribe onClose={handleClose} subscription={subscription} /> : ''}
        <h3> Last Transactions </h3>
        <DataTable
          head={lastTransactionsHeaders}
          body={lastTransactions}
          action={true}
          bodyColumn={lastTransactionsHeaders}
          linkPath={'transactions'}
          currentPage={page}
          noPagination={true}
          useUid={true}
        />
      </section>
    </>
  );
};

export default SubscriberInformation;
